import React from 'react';
import { Box, Container, Drawer, Link, Typography } from '@mui/material';
import { useAppSelector } from '../hooks';
import { selectUserProfile } from './accountSlice';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import { useLocation } from 'react-router-dom';
import useAuth from '../components/Auth';

const VerifyEmailNotification = () => {
	const myAccount = useAppSelector(selectUserProfile);
	const {pathname} = useLocation();
	const {logout} = useAuth();
	// Quick fix to reduce friction during setup account flow
	if (pathname.includes('/setup-account')) {
		return null;
	}
	return <Drawer variant='persistent' open={Boolean(myAccount && !myAccount.isEmailVerified)} anchor='bottom' sx={{zIndex: -1}}>
		<Container>
			<Box display='flex' alignItems='center' gap={2} py={2}>
				<PrivacyTipIcon />
				<Box>
					<Typography>Please verify your e-mail address to activate your account.</Typography>
					<Typography>Check your inbox for a verification email.</Typography>
					<Typography mt={1} variant='body2' color='warning'>You may need to <Link href='#' onClick={() => logout()}>log out</Link> and in again.</Typography>
				</Box>
			</Box>
		</Container>
	</Drawer>;
};

export default VerifyEmailNotification;